export const oemVehicleContentData = {
  others: {
    contentData: {
      heading: "Importance of Electric Commercial Vehicles",
      subheading:
        "Electric commercial vehicles hold significant importance due to their profitability and productivity, as outlined below:",
      listItems: [
        {
          listHead: "Cost Savings:",
          listItemText:
            "Electric commercial vehicles significantly reduce fuel expenses by utilizing chargeable electric batteries, leading to lower operational costs and enhanced profitability.",
        },
        {
          listHead: "Environmental Friendliness:",
          listItemText:
            "With their zero-emission solutions, these electric goods vehicles contribute to a cleaner environment.",
        },
        {
          listHead: "Carbon Footprint Reduction:",
          listItemText:
            "Designed to meet zero tailpipe engine norms, the battery electric vehicles at Turno help achieve zero carbon footprints, aiding in the journey towards carbon neutrality.",
        },
        {
          listHead: "Future-Proof Solution:",
          listItemText:
            "Embracing electric commercial vehicles from Turno ensures a future-proof transportation solution. By adopting these vehicles, businesses and individuals can also take advantage of the FAME-II subsidies provided by the Indian government.",
        },
        {
          listHead: "Enhanced Profitability:",
          listItemText:
            "Perfectly suited for both intracity and intercity logistics purposes, the electric cargo vehicles offered by Turno enable businesses to boost profits with reduced operating costs, maximizing efficiency and financial gains.",
        },
      ],
      contentText:
        "Choose from a range of renowned brands including Mahindra, Piaggio, OSM, Euler, and E-trio at Turno to find the perfect electric commercial vehicle for your specific needs.",
    },
    contentData2: {
      heading: "Our Electric Commercial Vehicles",
      subheading:
        "At Turno, we have established collaborations with renowned brands in the electric commercial vehicle industry, such as Mahindra, Piaggio, OSM, Etrio, Euler, and more. These manufacturers place a high emphasis on developing electric goods vehicles (GEVs) with ergonomic designs, ensuring not only functionality but also providing a delightful driving experience for operators. The focus on ergonomic designs contributes to enhanced business profitability by increasing efficiency and productivity.",
      listItems: [
        {
          listHead: "Mahindra Zor:",
          listItemText:
            "The Mahindra Treo Zor and Mahindra Treo Zor Grand are popular choices. They provide exceptional payload capacity, durability, and a low total cost of ownership. These models are perfect for last-mile delivery and intracity logistics.",
        },
        {
          listHead: "Piaggio Ape E-xtra FX and Piaggio Ape E-xtra FX Max:",
          listItemText:
            "The Piaggio Ape FX series of electric loading vehicles is known for its versatility and efficiency. With a compact design and excellent maneuverability, it is suitable for narrow city streets. The Ape FX Max variant offers an increased payload capacity, making it ideal for cargo transportation.",
        },
        {
          listHead: "Euler HiLoad DV and Euler HiLoad PV:",
          listItemText:
            "Euler HiLoad DV is a heavy-duty electric three-wheeler truck designed for demanding commercial applications. It offers high payload capacity and reliable performance. The HiLoad PV is a compact electric pickup truck suitable for various urban tasks.",
        },
        {
          listHead: "OSM Rage + 8.5 kWh and OSM Rage + 10.8 kWh:",
          listItemText:
            "The OSM Rage + series of goods electric vehicles is specifically designed for urban goods transportation. With its efficient electric drivetrain, it offers reliable performance and substantial payload capacity, making it an ideal choice for businesses.",
        },
        {
          listHead: "Etrio Touro Max++:",
          listItemText:
            "The Etrio Touro Max++ is a three-wheeler cargo electric vehicle with a spacious cabin and a high payload capacity. It is designed for efficiency and versatility, making it suitable for a range of commercial applications.",
        },
      ],
      contentText:
        "Trust Turno to provide you with reliable information about electric commercial vehicles. Contact us to learn more about the best prices, specifications, and other details regarding electric commercial vehicles.\n\n“Get the Best On-road Price”",
    },
    contentData3: {
      heading: "Maintenance of Electric Commercial Vehicles",
      subheading:
        "Turno provides doorstep servicing for commercial EVs, so you can have your vehicle maintained without having to take it to a workshop. Here are some of the benefits of using Turno for doorstep servicing of electric commercial vehicles:",
      listItems: [
        {
          listHead: "Convenience:",
          listItemText:
            "You can have your vehicle serviced at your location, so you don't have to take it to a workshop.",
        },
        {
          listHead: "Speed:",
          listItemText:
            "Turno's technicians can bring all the necessary tools and equipment to your location, so you can get your vehicle serviced quickly.",
        },
        {
          listHead: "Expertise:",
          listItemText:
            "Turno's technicians are trained to service all types of electric vehicles.",
        },
        {
          listHead: "Peace of mind:",
          listItemText:
            "You can be confident that your vehicle is being serviced by qualified technicians.",
        },
      ],
    },
    contentData4: {
      heading: "EV Battery type of 3 Wheeler Auto",
      subheading:
        "Lithium-ion (Li-ion) batteries are commonly used in electric goods vehicles, due to their high energy density and advanced safety features. Li-ion batteries undergo IP (Ingress Protection) certification to ensure protection against solids and liquids. The IP67-certified EV battery, for example, is dustproof and can withstand heavy rains. These batteries also incorporate safety mechanisms to prevent overheating, overcharging, and short circuits. The li-ion electric vehicle battery specifications are a balance of high energy density, longevity, and safety.Alongside, with Turno's in App battery health monitoring feature, users can maximize the lifespan of their electric vehicle batteries, optimize their performance, and make informed decisions regarding maintenance or replacement. ",
      heading2: "Electric Commercial Vehicle Financing from Turno",
      subheading2: "Process for Availing EV Finance from Turno:",
      listItems: [
        {
          listHead: "Application:",
          listItemText:
            "Applying for an electric vehicle finance from Turno is very easy. Just call Turno and the Turno Experts will initiate the application from.",
        },
        {
          listHead: "Documentation:",
          listItemText:
            "Provide the necessary documents as requested by Turno, which may include proof of identity, address, income, and business details.",
        },
        {
          listHead: "Evaluation:",
          listItemText:
            "Turno will evaluate your loan application and documentation to determine your eligibility and creditworthiness. Interest on EV loans will depend on the evaluation.",
        },
        {
          listHead: "Loan Options:",
          listItemText:
            "Turno will suggest you with the best loan option customized to your needs.",
        },
        {
          listHead: "Loan Approval:",
          listItemText:
            "Once you have selected a loan option, Turno will assist you in completing the loan application process, including the necessary paperwork.",
        },
        {
          listHead: "Agreement:",
          listItemText:
            "Once agreed to the terms and conditions e-sign the agreements.",
        },
        {
          listHead: "Loan Disbursement:",
          listItemText:
            "Upon approval from the lending institution, the loan amount will be disbursed.",
        },
        {
          listHead: "Vehicle Purchase:",
          listItemText:
            "With the loan amount available, you can proceed to purchase the desired electric vehicle from Turno.",
        },
      ],
      contentText:
        "Trust Turno to provide you with hassle-free electric vehicle financing solutions. Contact us to learn more about our financing options and get started with your electric vehicle purchase.",
    },
    contentData5: {
      heading: "How To Choose The Right Electric Loader For Your Business?",
      subheading:
        "When businesses are looking to choose the right electric loader, Turno is there to provide the best guidance. Our commitment to transparency and affordability ensures that businesses can make a well-informed and cost-effective investment in the right electric goods auto for their operations. The steps involved are:",
      listItems: [
        {
          listItemText:
            "We take a deep understanding of the customers' business details.",
        },
        {
          listItemText:
            "We suggest the best vehicle options that align with the unique needs of businesses.",
        },
        {
          listItemText:
            "We share the comprehensive vehicle details and specifications, highlighting how each option can contribute to the growth of the customer's business.",
        },
        {
          listItemText:
            "We take it a step further by offering an experiential test drive, allowing customers to witness firsthand how the battery electric vehicles perform with the specific loads and range requirements of the customer’s business. This hands-on experience ensures an informed decision-making process based on real-world scenarios.",
        },
        {
          listItemText:
            "In the end, we provide the best on-road electric vehicle price to the customer, that no other EV dealers can offer.",
        },
      ],
    },
  },
  osm: {
    USPs: {
      heading: "OSM Battery Electric Auto USPs:",
      listItems: [
        {
          listHead: "Safest battery in the market:",
          listItemText:
            "OSM EV Auto uses a lithium-ion battery that is one of the safest in the market. The battery is designed to withstand extreme temperatures and vibrations, and it is also protected from short circuits and overcharging.",
        },
        {
          listHead: "Pan India presence:",
          listItemText:
            "OSM EV Auto has a pan India presence, which means that you can find dealerships and service centres all over the country. This makes it easy to get your vehicle serviced or repaired, no matter where you are located.",
        },
        {
          listHead: "6 years battery warranty:",
          listItemText:
            "OSM EV Auto comes with a 6-year battery warranty, which is one of the longest in the industry. This means that you can be confident that your battery will last for many years to come.",
        },
        {
          listHead: "24*7 on-road charging assistance:",
          listItemText:
            "OSM EV Auto offers 24*7 on-road charging assistance, which means that you will never be stranded without power. If your battery runs out, you can call OSM and they will send a technician to your location to charge your vehicle.",
        },
      ],
    },
    Insights: {
      heading: "OSM Electric 3 Wheeler Insights:",
      listItems: [
        {
          listHead: "Cutting-edge Technology: ",
          listItemText:
            "OSM electric 3 wheelers are equipped with advanced technology, ensuring efficient performance and enhanced driving experience.",
        },
        {
          listHead: "Eco-friendly Solution: ",
          listItemText:
            " OSM electric 3 wheelers are zero-emission vehicles, contributing to a cleaner and greener environment. They help reduce carbon footprint and promote sustainable transportation.",
        },
        {
          listHead: "Cost-effective Operations:",
          listItemText:
            " With lower maintenance and operating costs compared to traditional fuel-powered vehicles, OSM electric 3 wheelers offer a cost-effective solution for businesses, allowing them to save on fuel expenses and maintenance charges. ",
        },
        {
          listHead: "Versatile Applications: ",
          listItemText:
            " OSM electric 3 wheelers are designed to cater to a wide range of applications, including last-mile delivery, urban commuting, and intra-city logistics, providing flexibility and versatility for various business needs.",
        },
        {
          listHead: "Reliable performance: ",
          listItemText:
            "OSM electric 3 wheelers are built to deliver reliable performance, ensuring smooth operations and optimal efficiency for businesses relying on them for their daily operations.",
        },
      ],
      contentText:
        "Experience the benefits of OSM Electric 3 Wheelers by contacting Turno today. Our dedicated team will assist you in finding the perfect OSM    ......vehicle to meet your specific requirements and help you embrace sustainable mobility.",
    },
  },

  piaggio: {
    USPs: {
      heading: "Piaggio ape auto USPs",
      subheading:
        "Piaggio pioneered the introduction of three-wheelers, specifically autos, for goods transportation in India. The Piaggio Ape, a renowned electric goods carrier, is widely used for light cargo, logistics, and local transportation. They offer a diverse portfolio of three-wheelers, including IC engine and electric variants like the Ape E-City and Ape E-Xtra, providing affordable options with strong battery life and extended range. The USPs of Piaggio Electrik are:",

      listItems: [
        {
          listHead: "Affordable transportation:",
          listItemText:
            "Piaggio electric vehicles offer cost-effective transportation solutions, helping businesses save on operating expenses.",
        },
        {
          listHead: "Long battery life:",
          listItemText:
            "With robust battery technology, Piaggio vehicles deliver reliable performance and extended battery life for uninterrupted operations.",
        },
        {
          listHead: "Extended vehicle range:",
          listItemText:
            "Piaggio electric vehicles provide an impressive range, ensuring increased flexibility and efficiency in transportation operations.",
        },
        {
          listHead: "Easy home charging:",
          listItemText:
            "Piaggio electric vehicles offer the convenience of home charging, allowing operators to conveniently recharge their vehicles overnight.",
        },
        {
          listHead: "Trust of Ape:",
          listItemText:
            "Piaggio's Ape brand is known for its trusted reputation and reliability, offering peace of mind to operators and businesses.",
        },
        {
          listHead: "6ft long carrier:",
          listItemText:
            "Piaggio electric load auto come with a spacious 6ft long carrier, providing ample space for transporting goods, making them suitable for various commercial applications.",
        },
      ],
    },
    Insights: {
      heading: " Insights  of Piaggio Auto Electric:",
      listItems: [
        {
          listHead: "Environment Friendly: ",
          listItemText:
            "The Piaggio Auto Electric produces zero emissions, contributing to a greener future by reducing air pollution and dependence on fossil fuels.",
        },
        {
          listHead: "Instant Torque: ",
          listItemText:
            "With its electric motor, the Piaggio ape auto delivers powerful acceleration, allowing for quick and efficient transportation, especially in urban areas where maneuverability is essential.",
        },
        {
          listHead: "Cost Savings: ",
          listItemText:
            "By relying on electricity instead of petrol, diesel or CNG, the Piaggio auto electric offers lower operating costs. Electricity is generally cheaper than all other fuels, resulting in significant savings over time. Additionally, the reduced need for maintenance and fewer mechanical parts contribute to lower maintenance expenses.",
        },
        {
          listHead: "Quiet and Smooth Ride: ",
          listItemText:
            "The electric motor of the Piaggio Ev 3 Wheeler operates silently, providing a quiet and peaceful journey. This feature not only enhances the overall comfort but also reduces noise pollution in both urban and rural areas.",
        },
        {
          listHead: "Long Range: ",
          listItemText:
            "The Piaggio ape electric auto features an extended battery life, allowing for longer travels without the need for frequent recharging. This extended range offers convenience and flexibility, making it suitable for various applications, including delivery services and personal transportation.",
        },
      ],
    },
    aboutPiaggio: {
      heading: "About the Piaggio Ape Electric",
      listItems: [
        {
          listHead: "Piaggio Vehicles:",
          listItemText:
            "As a prominent Italian company, Piaggio is Europe's largest manufacturer of scooters and motorcycles. In India, they are a major player in the three-wheeler/auto-rickshaw segment, catering to both passenger and cargo needs. Piaggio specializes in scooters, motorcycles, light commercial vehicles, and innovative robotics. With their pioneering Ape model, Piaggio established a strong presence in the commercial vehicle market since 1948. Their Piaggio mini trucks excel in fuel efficiency and load-bearing capabilities.",
        },
        {
          listHead: "Customer Service: ",
          listItemText:
            "Piaggio is known for its exceptional customer care services, providing guidance and solutions to transporters and truck drivers. Their light commercial vehicles integrate state-of-the-art technology and efficient workforce management, offering high capability, low ownership costs, and addressing buyer's concerns.",
        },
        {
          listHead: "Piaggio’s Business: ",
          listItemText:
            "Piaggio's business has expanded across 50 countries, with a strong presence in the Asian market. Initially known for the iconic Vespa scooter, they now offer premium scooters and top-notch light commercial vehicles. Piaggio started operations in India in 1999, with their first production unit in Baramati near Pune, focusing on the development and manufacturing of the iconic Piaggio Ape auto.",
        },
      ],
    },
  },
  mahindra: {
    USPs: {
      heading: "Mahindra Commercial vehicles USPs:",
      subheading:
        "Mahindra electric commercial vehicles offer maintenance-free operations, ensuring hassle-free ownership. Choose savings and reliability with these Mahindra cargos that require minimal maintenance. Take home the Mahindra load auto for efficient and profitable transportation while enjoying the benefits of worry-free operations.",
    },
    Highlights: {
      heading: "Highlights of Mahindra Electric Auto’s:      ",
      subheading:
        "Choose Mahindra electric auto, the most trusted Indian brand, known for their business-friendly features, advanced technology, and practicality. Turno proudly offers a wide range of Mahindra commercial vehicles, including:",

      listItems: [
        {
          listHead: "Advanced battery technology: ",
          listItemText:
            "Mahindra electric loading vehicles utilize advanced battery technology, offering efficient energy storage and extended range capabilities. These vehicles are equipped with cutting-edge battery systems that provide reliable performance and optimal power management.",
        },
        {
          listHead: "Segment-best comfort:",
          listItemText:
            "Mahindra electric loading vehicles prioritize driver comfort, offering ergonomic design and features that ensure a comfortable driving experience even during long hours on the road.",
        },
        {
          listHead: "Higher savings: ",
          listItemText:
            "Mahindra goods vehicles offer significant cost savings compared to traditional diesel-powered counterparts. They have lower operating costs, reduced maintenance expenses, and potential government incentives, resulting in higher savings for businesses.",
        },
        {
          listHead: "High safety: ",
          listItemText:
            "Mahindra Trucks are designed with safety in mind, featuring sturdy construction, advanced safety features, and compliance with safety standards. These vehicles prioritize the well-being of the driver and cargo.",
        },
        {
          listHead: "Cloud-based mobility platform:  ",
          listItemText:
            "Mahindra goods vehicles integrate a cloud-based mobility platform, enabling advanced connectivity and smart features. This platform enhances vehicle management, remote monitoring, and data analysis for optimized performance and operational efficiency.",
        },
      ],
    },
    HighlightsHindi: {
      heading: "महिंद्रा इलेक्ट्रिक ऑटो की विशेषताएँ:",
      subheading:
        "महिंद्रा इलेक्ट्रिक ऑटो को चुनें क्योंकि यह  भारत का सबसे विश्वसनीय ब्रांड हैं। यह अपने व्यापार अनुकूलता  और प्रगतिशीलता के लिए प्रसिद्ध हैं।टर्नो पेश करता हैं महिंद्रा की इलेक्ट्रिक गाड़ियां  जिसपे आपको मिलता हैं -",

      listItems: [
        {
          listHead: "एडवांस्ड बैटरी तकनीक:",
          listItemText:
            "महिंद्रा इलेक्ट्रिक लोडिंग गाड़ीयाँ एडवांस्ड बैटरी का उपयोग करती हैंं, जो अधिक ऊर्जा उप्तन्न करके  लम्बी दूरी की यात्रा में मदद करती हैंं। इन गाड़ियों का निर्माण में उन्नत बैटरियों का इस्तमाल किया हैं, इसलिए इनका संचालन शक्तिशाली होता हैं।",
        },
        {
          listHead: "ड्राइवर की सुविधा:",
          listItemText:
            "महिंद्रा इलेक्ट्रिक लोडिंग गाड़ी ड्राइवर की सुविधा को प्राथमिकता देती हैं। इसमें एर्गोनॉमिक डिज़ाइन होता हैं, जो कई सारी सुविधाएँ प्रदान करती हैं और लम्बी यात्रा आरामदायक बनाती हैं।",
        },
        {
          listHead: "ज्यादा बचत:",
          listItemText:
            "महिंद्रा गुड्स गाड़ी पारंपरिक डीज़ल गाड़ियों की तुलना में ज्यादा बचत करती हैं। इसको चलाने और रखरखाव की लागत कम होती हैं। इसपर सरकार की ओर से सब्सिडी भी मिलती हैं, जिससे व्यापारी आसानी से अधिक बचत कर सकते हैंं।",
        },
        {
          listHead: "बेहतर सुरक्षा:",
          listItemText:
            "महिंद्रा इलेक्ट्रिक टेम्पो सुरक्षा को ध्यान में रखकर डिज़ाइन किए गए हैंं, जिसमें मजबूत निर्माण, उन्नत सुरक्षा सुविधाएँ, और सुरक्षा मानको का पालन शामिल हैं। इस गाड़ी में ड्राइवर और सामग्री की रक्षा को प्राथमिकता दी गई हैं।",
        },
        {
          listHead: "मोबाइल ऍप:",
          listItemText:
            "महिंद्रा गुड्स गाड़ी एक क्लाउड-आधारित मोबाइल ऍप प्रदान करती हैं, जो अच्छी कनेक्टिविटी और स्मार्ट सुविधाएँ प्रदान करता हैं। इसके माध्यम से गाड़ी को मैनेज करना, मॉनिटरिंग करना, और डेटा विश्लेषण किया जा सकता हैं।",
        },
      ],
    },
    HighlightsKannada: {
      heading: "ಮಹೀಂದ್ರಾ ಎಲೆಕ್ಟ್ರಿಕ್ ಆಟೋಗಳ ಮುಖ್ಯಾಂಶಗಳು:",
      subheading:
        "ತಮ್ಮ ವ್ಯಾಪಾರ-ಸ್ನೇಹಿ ವೈಶಿಷ್ಟ್ಯಗಳು, ಸುಧಾರಿತ ತಂತ್ರಜ್ಞಾನ ಮತ್ತು ಪ್ರಾಯೋಗಿಕತೆಗೆ ಹೆಸರುವಾಸಿಯಾದ ಅತ್ಯಂತ ವಿಶ್ವಾಸಾರ್ಹ ಭಾರತೀಯ ಬ್ರ್ಯಾಂಡ್ ಮಹೀಂದ್ರಾ ಎಲೆಕ್ಟ್ರಿಕ್ ಆಟೋವನ್ನು ಆಯ್ಕೆಮಾಡಿ. ಟರ್ನೊ ಹೆಮ್ಮೆಯಿಂದ ಮಹೀಂದ್ರಾ ವಾಣಿಜ್ಯ ವಾಹನಗಳ ವ್ಯಾಪಕ ಶ್ರೇಣಿಯನ್ನು ಒದಗಿಸುತ್ತದೆ, ಅವುಗಳೆಂದರೆ:",

      listItems: [
        {
          listHead: "ಸುಧಾರಿತ ಬ್ಯಾಟರಿ ತಂತ್ರಜ್ಞಾನ:",
          listItemText:
            "ಮಹೀಂದ್ರಾ ಎಲೆಕ್ಟ್ರಿಕ್ ಲೋಡಿಂಗ್ ವಾಹನಗಳು ಸುಧಾರಿತ ಬ್ಯಾಟರಿ ತಂತ್ರಜ್ಞಾನವನ್ನು ಬಳಸಿಕೊಳ್ಳುತ್ತವೆ, ಸಮರ್ಥ ಶಕ್ತಿ ಸಂಗ್ರಹಣೆ ಮತ್ತು ವಿಸ್ತೃತ ಶ್ರೇಣಿಯ ಸಾಮರ್ಥ್ಯಗಳನ್ನು ನೀಡುತ್ತವೆ. ಈ ವಾಹನಗಳು ಅತ್ಯಾಧುನಿಕ ಬ್ಯಾಟರಿ ವ್ಯವಸ್ಥೆಗಳನ್ನು ಹೊಂದಿದ್ದು ಅದು ವಿಶ್ವಾಸಾರ್ಹ ಕಾರ್ಯಕ್ಷಮತೆ ಮತ್ತು ಅತ್ಯುತ್ತಮ ವಿದ್ಯುತ್ ನಿರ್ವಹಣೆಯನ್ನು ಒದಗಿಸುತ್ತದೆ.",
        },
        {
          listHead: "ಸೆಗ್ಮೆಂಟ್-ಅತ್ಯುತ್ತಮ ಸೌಕರ್ಯ: ",
          listItemText:
            "ಮಹೀಂದ್ರಾ ಎಲೆಕ್ಟ್ರಿಕ್ ಲೋಡಿಂಗ್ ವಾಹನಗಳು ಚಾಲಕ ಸೌಕರ್ಯಗಳಿಗೆ ಆದ್ಯತೆ ನೀಡುತ್ತವೆ, ರಸ್ತೆಯಲ್ಲಿ ದೀರ್ಘಾವಧಿಯಲ್ಲಿಯೂ ಆರಾಮದಾಯಕ ಚಾಲನಾ ಅನುಭವವನ್ನು ಖಾತ್ರಿಪಡಿಸುವ ವೈಶಿಷ್ಟ್ಯಗಳನ್ನು ನೀಡುತ್ತವೆ.",
        },
        {
          listHead: "ಚ್ಚಿನ ಉಳಿತಾಯ:",
          listItemText:
            "ಸಾಂಪ್ರದಾಯಿಕ ಡೀಸೆಲ್-ಚಾಲಿತ ಕೌಂಟರ್‌ಪಾರ್ಟ್‌ಗಳಿಗೆ ಹೋಲಿಸಿದರೆ ಮಹೀಂದ್ರ ಲೋಡರ್ ವಾಹನಗಳು ಗಮನಾರ್ಹ ವೆಚ್ಚ ಉಳಿತಾಯವನ್ನು ನೀಡುತ್ತವೆ. ಅವರು ಕಡಿಮೆ ನಿರ್ವಹಣಾ ವೆಚ್ಚಗಳು ಮತ್ತು ಸಂಭಾವ್ಯ ಸರ್ಕಾರಿ ಪ್ರೋತ್ಸಾಹಗಳನ್ನು ಹೊಂದಿದ್ದಾರೆ, ಇದರಿಂದಾಗಿ ವ್ಯವಹಾರಗಳಿಗೆ ಹೆಚ್ಚಿನ ಉಳಿತಾಯವಾಗುತ್ತದೆ.",
        },
        {
          listHead: "ಹೆಚ್ಚಿನ ಸುರಕ್ಷತೆ:",
          listItemText:
            "ಮಹೀಂದ್ರಾ ಎಲೆಕ್ಟ್ರಿಕ್ ಟೆಂಪೋವನ್ನು ಸುರಕ್ಷತೆಯನ್ನು ಗಮನದಲ್ಲಿಟ್ಟುಕೊಂಡು ವಿನ್ಯಾಸಗೊಳಿಸಲಾಗಿದೆ, ಗಟ್ಟಿಮುಟ್ಟಾದ ನಿರ್ಮಾಣ, ಸುಧಾರಿತ ಸುರಕ್ಷತಾ ವೈಶಿಷ್ಟ್ಯಗಳು ಮತ್ತು ಸುರಕ್ಷತಾ ಮಾನದಂಡಗಳ ಅನುಸರಣೆಯನ್ನು ಒಳಗೊಂಡಿದೆ. ಈ ವಾಹನಗಳು ಚಾಲಕ ಮತ್ತು ಸರಕುಗಳ ಯೋಗಕ್ಷೇಮಕ್ಕೆ ಆದ್ಯತೆ ನೀಡುತ್ತವೆ.",
        },
        {
          listHead: "ಕ್ಲೌಡ್-ಆಧಾರಿತ ಮೊಬಿಲಿಟಿ ಪ್ಲಾಟ್‌ಫಾರ್ಮ್:",
          listItemText:
            "ಕ್ಲೌಡ್-ಆಧಾರಿತ ಮೊಬಿಲಿಟಿ ಪ್ಲಾಟ್‌ಫಾರ್ಮ್: ಮಹೀಂದ್ರಾ ಸರಕುಗಳ ವಾಹನಗಳು ಕ್ಲೌಡ್-ಆಧಾರಿತ ಮೊಬಿಲಿಟಿ ಪ್ಲಾಟ್‌ಫಾರ್ಮ್ ಅನ್ನು ಸಂಯೋಜಿಸುತ್ತವೆ, ಸುಧಾರಿತ ಸಂಪರ್ಕ ಮತ್ತು ಸ್ಮಾರ್ಟ್ ವೈಶಿಷ್ಟ್ಯಗಳನ್ನು ಸಕ್ರಿಯಗೊಳಿಸುತ್ತವೆ. ಈ ಪ್ಲಾಟ್‌ಫಾರ್ಮ್ ವಾಹನ ನಿರ್ವಹಣೆ, ರಿಮೋಟ್ ಮಾನಿಟರಿಂಗ್ ಮತ್ತು ಆಪ್ಟಿಮೈಸ್ಡ್ ಕಾರ್ಯಕ್ಷಮತೆ ಮತ್ತು ಕಾರ್ಯಾಚರಣೆಯ ದಕ್ಷತೆಗಾಗಿ ಡೇಟಾ ವಿಶ್ಲೇಷಣೆಯನ್ನು ಹೆಚ್ಚಿಸುತ್ತದೆ.",
        },
      ],
    },
    aboutMahindra: {
      heading: "About Mahindra Electric Auto:",
      description:
        "Mahindra Commercial Electric Autos, including the Mahindra Treo Zor and Mahindra Zor Grand, offer superior features compared to traditional IC engine auto-rickshaws. With amenities like a windscreen & wiping system, spare wheel provision, three driving modes, lockable glove box, grab handles, 12V socket, hazard indicator, optional telematics unit & GPS, and a 15A off-board charger, Mahindra electric autos provide enhanced convenience and reliability for commercial purposes. Experience the advanced features of Mahindra Commercial Electric Autos through Turno.      ",
    },
  },

  euler: {
    Insights: {
      heading: "Euler Electric 3 Wheelers : Best-in-class vehicles",
      listItems: [
        {
          listHead: "Cutting-edge Technology: ",
          listItemText:
            " Euler Hiload EVs are equipped with advanced technology, ensuring efficient performance and enhanced driving experience.",
        },
        {
          listHead: "Eco-friendly Solution:",
          listItemText:
            "Both the EV variants sold by Euler Motor are zero-emission vehicles, contributing to a cleaner and greener environment. They help reduce carbon footprint and promote sustainable transportation.",
        },
        {
          listHead: "Cost-effective Operations:",
          listItemText:
            "With lower maintenance and operating costs compared to traditional fuel-powered vehicles, Euler three wheelers offer a cost-effective solution for businesses, allowing them to save on fuel expenses and maintenance charges.",
        },
        {
          listHead: "Reliable Performance:",
          listItemText:
            "Euler electric vehicles are built to deliver reliable performance, ensuring smooth operations and optimal efficiency for businesses relying on them for their daily operations.",
        },
      ],
    },
    USPs: {
      heading: "USPs of Euler electric vehicle",
      listItems: [
        {
          listHead: "Advanced battery:",
          listItemText:
            "Euler EV autos use a lithium-ion battery that comes in a liquid-cooled battery pack with ArcReactor technology - one of the safest in the market.",
        },
        {
          listHead: "Growing presence:",
          listItemText:
            "Euler Electric Auto has a growing presence, which means that you can find dealerships and service centres in many centres all over the nation. This makes it easy to get your vehicle’s battery serviced or repaired, no matter where you are located.",
        },
        {
          listHead: "Flash27 charger: ",
          listItemText:
            "Euler 3 Wheelers come with a fast charger that gives you a 26kW lightning charging option. So, you get a 50km charge within 15 minutes.",
        },
        {
          listHead: "Anytime charging:",
          listItemText:
            "Euler electric vehicles offer an onboard charger so that you can charge your EV on the go. You can also check the status on Euler Shepherd and even book a charging unit or on-road assistance.",
        },
      ],
    },
  },
  etrio: {
    Insights: {
      heading: "Etrio Electric 3 Wheeler Insights",
      listItems: [
        {
          listHead: "Cutting-edge Technology:",
          listItemText:
            "Etrio electric three-wheelers are equipped with advanced technology, ensuring efficient performance and enhanced driving experience.",
        },
        {
          listHead: "Eco-friendly Solution:",
          listItemText:
            "Etrio electric three-wheelers are zero-emission vehicles, contributing to a cleaner and greener environment. They help reduce carbon footprint and promote sustainable transportation.",
        },
        {
          listHead: "Cost-effective Operations:",
          listItemText:
            "With lower maintenance and operating costs compared to traditional fuel-powered vehicles, Etrio electric three-wheelers offer a cost-effective solution for businesses, allowing them to save on fuel expenses and maintenance charges.",
        },
        {
          listHead: "Reliable Performance:",
          listItemText:
            "Etrio electric three-wheelers are built to deliver reliable performance, ensuring smooth operations and optimal efficiency for businesses relying on them for their daily operations.",
        },
      ],
    },
    USPs: {
      heading: "Etrio Battery Electric Auto USPs",
      listItems: [
        {
          listHead: "Safest battery in the market:",
          listItemText:
            "Etrio EV Auto uses a lithium-ion battery that is one of the safest in the market. The battery is designed to withstand extreme temperatures and vibrations, and it is also protected from short circuits and overcharging.",
        },
        {
          listHead: "Growing presence:",
          listItemText:
            "Etrio EV Auto has a growing presence, which means that you can find dealerships and service centers in 6 centers over the country. This makes it easy to get your vehicle serviced or repaired, no matter where you are located.",
        },
        {
          listHead: "3 years battery warranty:",
          listItemText:
            "Etrio EV Auto comes with a 3-year battery warranty, which is one of the longest in the industry. This means that you can be confident that your battery will last for many years to come.",
        },
        {
          listHead: "24*7 on-road charging assistance:",
          listItemText:
            "Etrio EV Auto offers 24*7 on-road charging assistance, which means that you will never be stranded without power. If your battery runs out, you can call Etrio, and they will send a technician to your location to charge your vehicle.",
        },
      ],
    },
  },
  altigreen: {
    Insights: {
      heading: "Altigreen Electric 3 Wheeler Insights: ",
      listItems: [
        {
          listHead: "Innovative Engineering:",
          listItemText:
            "Altigreen Electric 3 Wheeler exemplifies innovative engineering, integrating cutting-edge technology for enhanced performance and efficiency.",
        },
        {
          listHead: "Last-Mile Excellence:",
          listItemText:
            " Designed to excel in last-mile delivery, Altigreen 3 Wheelers offer practicality and convenience, catering to urban logistics requirements.",
        },
        {
          listHead: "Extended Range",
          listItemText:
            "With an impressive certified range of 150 km, this electric 3-wheeler ensures consistent and extended operations without frequent recharging.",
        },
        {
          listHead: "Powerful Performance:",
          listItemText:
            "Equipped with 8.25 kW peak power and 45 Nm torque, Altigreen's 3 Wheeler delivers a dynamic and efficient driving experience.",
        },
        {
          listHead: "Efficient Regeneration",
          listItemText:
            "Regenerative braking technology optimises energy conservation, charging the battery during deceleration and enhancing overall range.",
        },
        {
          listHead: "Adaptable Mobility:",
          listItemText:
            "A top speed of 53 kmph and a generous ground clearance of 220 mm empower this 3-wheeler to navigate diverse urban terrains with ease.",
        },
        {
          listHead: "Economical Operations",
          listItemText:
            "Boasting a running cost of just 0.92 paise per kilometre, Altigreen Electric 3 Wheeler offers economic advantages for businesses.",
        },
        {
          listHead: "Pioneering Legacy:",
          listItemText:
            "Supported by 28 global patents, Altigreen's innovation and legacy in electric mobility shine through in every aspect of this 3-wheeler.",
        },
      ],
    },
    USPs: {
      heading: "Altigreen Battery Electric Auto USPs:",
      listItems: [
        {
          listHead: "Advanced Technology:",
          listItemText:
            "Altigreen Battery Electric Auto incorporates advanced engineering and technology, setting a new standard for electric vehicles in the market.",
        },
        {
          listHead: "Impressive Range:",
          listItemText:
            "With an 11 kWh battery and certified range of 150 km, Altigreen's Electric Auto ensures extended journeys without compromising on efficiency.",
        },
        {
          listHead: "Efficient Performance:",
          listItemText:
            "Boasting 8.25 kW peak power and 45 Nm torque, this vehicle offers powerful yet efficient performance on diverse terrains.",
        },
        {
          listHead: "Regenerative Braking",
          listItemText:
            "Innovative regenerative braking technology charges the battery during deceleration, optimising energy usage and extending the range.",
        },
        {
          listHead: "Manoeuvrability:",
          listItemText:
            "With a top speed of 53 kmph and a ground clearance of 220 mm, Altigreen Electric Auto navigates Indian roads with ease and confidence.",
        },
        {
          listHead: "Eco-Friendly Solution:",
          listItemText:
            "Altigreen's commitment to sustainability shines through in this electric auto, providing an eco-friendly transportation solution.",
        },
        {
          listHead: "Cost-Effective",
          listItemText:
            "Offering a running cost of just 0.92 paise per kilometre, Altigreen Battery Electric Auto delivers economic benefits along with environmental consciousness.",
        },
        {
          listHead: "Pioneering Innovation",
          listItemText:
            "Backed by 28 global patents, this vehicle showcases Altigreen's dedication to pioneering innovation in the electric vehicle industry.",
        },
      ],
    },
  },
  greaves: {
    Insights: {
      heading: "Greaves Electric 3 Wheeler Insights:",
      listItems: [
        {
          listHead: "Innovative Engineering:",
          listItemText:
            "Greaves Electric 3 Wheelers exemplify innovative engineering, integrating cutting-edge technology for enhanced performance and efficiency.",
        },
        {
          listHead: "Last-Mile Excellence:",
          listItemText:
            "Designed to excel in last-mile delivery, Greaves Electric 3 Wheelers offer practicality and convenience, catering to urban logistics requirements.",
        },
        {
          listHead: "Extended Range:",
          listItemText:
            "With an impressive certified range, these electric 3-wheelers ensure consistent and extended operations without frequent recharging.",
        },
        {
          listHead: "Powerful Performance:",
          listItemText:
            "Equipped with peak power and torque, Greaves Electric 3 Wheelers deliver a dynamic and efficient driving experience.",
        },
        {
          listHead: "Efficient Regeneration:",
          listItemText:
            "Regenerative braking technology optimizes energy conservation, charging the battery during deceleration and enhancing overall range.",
        },
        {
          listHead: "Adaptable Mobility:",
          listItemText:
            "High speed and ground clearance empower these 3-wheelers to navigate diverse urban terrains with ease.",
        },
        {
          listHead: "Economical Operations:",
          listItemText:
            "Boasting a running cost, Greaves Electric 3 Wheelers offer economic advantages for businesses.",
        },
        {
          listHead: "Pioneering Legacy:",
          listItemText:
            "Supported by innovation and legacy in electric mobility, Greaves Electric 3 Wheelers showcase advanced technology and engineering.",
        },
      ],
    },
    USPs: {
      heading: "Greaves Electric Vehicle USPs:",
      listItems: [
        {
          listHead: "Cutting-edge Technology:",
          listItemText:
            "Greaves Electric Vehicles incorporate advanced engineering and technology, setting a new standard for electric vehicles in the market.",
        },
        {
          listHead: "Impressive Battery Life:",
          listItemText:
            "With efficient battery systems, Greaves Electric Vehicles ensure extended journeys without compromising on efficiency.",
        },
        {
          listHead: "Efficient Performance:",
          listItemText:
            "These vehicles offer powerful yet efficient performance on diverse terrains.",
        },
        {
          listHead: "Regenerative Braking:",
          listItemText:
            "Innovative regenerative braking technology optimizes energy usage and extends the range.",
        },
        {
          listHead: "Adaptable Mobility:",
          listItemText:
            "With top-notch features, Greaves Electric Vehicles navigate Indian roads with ease and confidence.",
        },
        {
          listHead: "Eco-Friendly Solution:",
          listItemText:
            "Greaves Electric Vehicles contribute to a sustainable future with their eco-friendly transportation solution.",
        },
        {
          listHead: "Cost-Effective:",
          listItemText:
            "Offering an economical running cost, Greaves Electric Vehicles deliver financial benefits along with environmental consciousness.",
        },
        {
          listHead: "Pioneering Innovation:",
          listItemText:
            "Greaves Electric Vehicles showcase innovation in the electric vehicle industry, backed by advanced technology and engineering.",
        },
      ],
    },
  },
};
